import { PAY_NOW_STATE } from './constants'

export const getIsFetching = state => state[PAY_NOW_STATE]?.isFetching
export const getSecureCode = state => state[PAY_NOW_STATE]?.secureCode
